import { useTranslation } from "react-i18next";
import clientPortal from "../../assets/ClientPortalAPP.png";
import { Globe, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const buttonVariants = {
  initial: { scale: 1 },
  hover: { scale: 1.05 },
};

const arrowVariants = {
  initial: { x: 0 },
  hover: { x: 6 },
};

export default function ClientPortalSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-10 lg:my-6 my-4 lg:rounded-3xl bg-defaultGreen/10 dark:bg-defaultGreen/20 container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ">
          {/* Animated Image */}
          <motion.div
            className="relative order-2 md:order-1"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <img src={clientPortal} alt="Dashboard Preview" className="" />
          </motion.div>
          {/* Animated Text Content */}
          <motion.div
            className="space-y-8 order-1 md:order-2"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center space-x-2 bg-defaultGreen p-2 rounded-full">
              <Globe className="w-5 h-5 text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
              Client Portal
            </h1>
            <p className="text-xl text-gray-600 dark:text-white/70">
              {t("productsPage.clientPortal_description")}
            </p>
            <motion.a
              href="https://portal.uplus.rw/create-an-account"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-defaultGreen text-white font-semibold rounded-lg transition-colors"
              variants={buttonVariants}
              initial="initial"
              whileHover="hover"
              whileTap={{ scale: 0.97 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              {t("productsPage.clientPortal_link")}
              <motion.span
                className="ml-2 flex"
                variants={arrowVariants}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <ArrowRight className="w-5 h-5" />
              </motion.span>
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
